<template>
  <div>
    <v-flex d-flex align-center>
      <v-subheader class="font-weight-bold">
        <span id="devices__rows">
          <span id="devices__total-string">Total: </span>
          <span id="devices__rows-count">{{ rowsCount }}</span>
        </span>
      </v-subheader>
      <v-spacer></v-spacer>
      <template v-if="isHomeFilterShow">
        <div class="text-center">
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :label="$t('actions.filter')"
                append-icon="mdi-menu-down"
                v-bind="attrs"
                v-on="on"
                v-model="filter"
                readonly
                clearable
                @click:clear="handleClear"
              ></v-text-field>
            </template>
            <v-card>
              <v-card-text class="pt-0">
                <v-radio-group
                  v-model="activated"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                >
                  <v-subheader
                    class="ma-0 pa-0 mb-2 subtitle-1 font-weight-bold"
                  >
                    {{ $t("modules.devices.filter.activationFilter") }}
                  </v-subheader>
                  <v-radio
                    v-for="(item, index) in homeActivatedFilters"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="enabled"
                  dense
                  hide-details
                  class="mt-2 pt-0"
                >
                  <v-subheader
                    class="ma-0 pa-0 mb-2 subtitle-1 font-weight-bold"
                  >
                    {{ $t("modules.devices.filter.enabledDisabledFilter") }}
                  </v-subheader>
                  <v-radio
                    v-for="(item, index) in homeEnabledFIlters"
                    :key="index"
                    :label="item.text"
                    :value="item.value"
                  >
                  </v-radio>
                </v-radio-group>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </template>
      <v-flex d-flex align-center v-else>
        <v-select
          clearable
          v-model="activated"
          :items="activatedFilters"
          :label="$t('modules.devices.filter.activationFilter')"
          style="width: 100px"
          class="mx-2"
        ></v-select>
        <v-select
          clearable
          v-model="enabled"
          :items="enabledFilters"
          :label="$t('modules.devices.filter.enabledDisabledFilter')"
          style="width: 100px"
          class="mx-2"
        ></v-select>
      </v-flex>
      <v-text-field
        v-model="search"
        :label="$t('actions.search')"
        class="mx-2"
        prepend-icon="mdi-magnify"
        single-line
        clearable
      ></v-text-field>
    </v-flex>
    <v-data-table
      v-model="selected"
      ref="dataContainer"
      :headers="headers"
      :items="loadItems"
      :class="'elevation-1 scroll ' + cssClass"
      :loading="loading"
      hide-default-footer
      :options.sync="options"
      style="min-height: 100%;"
      id="devices__table"
      must-sort
      sort-by="availability"
      sort-desc
      fixed-header
      :height="height - 15 + 'px'"
      @click:row="selectRow"
    >
      <template v-slot:body.append>
        <td
          colspan="5"
          class="text-center py-2"
          v-if="options.itemsPerPage < loadItems.length"
        >
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </td>
      </template>
      <template v-slot:item.versions="props">
        <v-tooltip bottom :disabled="!props.item.halo_system_report">
          <template v-slot:activator="{ on, attrs }">
            <span v-on="on" v-bind="attrs">
              {{
                props.item.halo_system_report
                  ? props.item.halo_system_report.version.official
                  : ""
              }}
            </span>
          </template>
          <div v-if="props.item.halo_system_report">
            <div>
              {{ props.item.halo_system_report.version.base }} ({{
                $t("modules.home.base")
              }})
            </div>
            <div>
              {{ props.item.halo_system_report.version.core }} ({{
                $t("modules.home.core")
              }})
            </div>
            <div>
              {{ props.item.halo_system_report.version.web }} ({{
                $t("modules.home.web")
              }})
            </div>
          </div>
        </v-tooltip>
      </template>
      <template v-slot:item.is_server="props">
        <v-simple-checkbox
          color="primary"
          hide-details
          class="align-center justify-center"
          disabled
          v-model="props.item.is_server"
        />
      </template>
      <template v-slot:item.is_activated="props">
        <v-simple-checkbox
          color="primary"
          hide-details
          class="align-center justify-center"
          disabled
          v-model="props.item.is_activated"
        />
      </template>
      <template v-slot:item.is_enabled="props">
        <v-simple-checkbox
          color="primary"
          hide-details
          class="align-center justify-center"
          disabled
          v-model="props.item.is_enabled"
        />
      </template>
      <template v-slot:item.membership="props">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on" v-html="loadMembership(props.item).title"></span>
          </template>
          <span v-html="loadMembership(props.item).membership"></span>
        </v-tooltip>
      </template>
      <template v-slot:item.latest_location="props">
        <v-icon
          v-if="
            props.item.latest_location && props.item.latest_location.status > 0
          "
          :color="props.item.latest_location.status === 2 ? 'green' : 'grey'"
          >mdi-map-marker</v-icon
        >
      </template>
      <template v-slot:item.action="props">
        <v-container>
          <v-row class="flex-nowrap">
            <v-btn
              color="primary"
              small
              class="mr-6"
              :disabled="!isPermitted(PermissionEnum.RF_RECORDINGS.VIEW)"
              @click="openRfRecordingDialog(props.item.id)"
              >{{ $t("modules.devices.rfRecordings.viewRecordings") }}</v-btn
            >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-6"
                  @click="editItem(props.item)"
                  :id="'devices__edit-' + props.index"
                  :disabled="
                    !(
                      isPermitted(PermissionEnum.DEVICES.UPDATE_ALL) ||
                      isPermittedDevice(
                        PermissionEnum.DEVICES.UPDATE,
                        props.item.id
                      )
                    )
                  "
                  v-on="on"
                  v-bind="attrs"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>{{ $t("actions.edit") }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click="deleteItem(props.item)"
                  :id="'devices__delete-' + props.index"
                  :disabled="
                    !(
                      isPermitted(PermissionEnum.DEVICES.DELETE_ALL) ||
                      isPermittedDevice(
                        PermissionEnum.DEVICES.DELETE,
                        props.item.id
                      )
                    )
                  "
                  v-bind="attrs"
                  v-on="on"
                  >mdi-delete</v-icon
                >
              </template>
              <span>{{ $t("actions.delete") }}</span>
            </v-tooltip>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { handleError } from "@/utils/error";
import { mapGetters } from "vuex";
import { devicesMixins } from "@/modules/devices/mixins";
import { periodicCall } from "@/utils";
import constants from "@/utils/constants";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "DevicesTable",
  props: {
    headers: Array,
    hasSelection: {
      type: Boolean,
      default: false
    },
    cssClass: String,
    isHomeFilterShow: {
      type: Boolean,
      default: false
    }
  },
  mixins: [devicesMixins, permissionMixin],
  data() {
    return {
      height: 0,
      rows: 20,
      activated: null,
      loadItems: [],
      menu: [],
      options: {},
      loading: false,
      activatedFilters: [
        {
          text: this.$t("modules.devices.activated"),
          value: true
        },
        {
          text: this.$t("modules.devices.notActivated"),
          value: false
        }
      ],
      enabled: null,
      enabledFilters: [
        {
          text: this.$t("modules.devices.enabled"),
          value: true
        },
        {
          text: this.$t("modules.devices.disabled"),
          value: false
        }
      ],
      editedIndex: -1,
      intervalId: null
    };
  },

  watch: {
    search() {
      this.filterDevices();
    },
    devices() {
      this.filterDevices();
    },
    activated() {
      this.filterDevices();
    },
    enabled() {
      this.filterDevices();
    }
  },

  computed: {
    ...mapGetters("login", ["loggedInUsersDevices"]),
    dialog: {
      get() {
        return this.$store.state.devices.dialog;
      },
      set(val) {
        this.$store.dispatch("devices/toggleDialog", val);
      }
    },
    selected: {
      get() {
        return this.$store.state.devices.selected;
      },
      set(val) {
        this.$store.commit("devices/updateSelected", val);
      }
    },
    search: {
      get() {
        return this.$store.state.devices.search || "";
      },
      set(val) {
        this.$store.commit("devices/updateSearch", val);
      }
    },
    editedItem() {
      return this.$store.state.devices.editedItem;
    },
    rowsCount() {
      return this.loadItems.length;
    },
    homeActivatedFilters() {
      return [
        {
          text: this.$t("modules.devices.activatedAndNotActivated"),
          value: null
        },
        ...this.activatedFilters
      ];
    },
    homeEnabledFIlters() {
      return [
        {
          text: this.$t("modules.devices.enabledAndDisabled"),
          value: null
        },
        ...this.enabledFilters
      ];
    },
    filter: {
      get() {
        let text = "";
        if (this.activated !== null) {
          text += this.activatedFilters.find(
            item => item.value === this.activated
          ).text;
        }

        if (this.enabled !== null) {
          if (text !== "") {
            text += " & ";
          }

          text += this.enabledFilters.find(item => item.value === this.enabled)
            .text;
        }

        return text;
      },
      set() {
        return;
      }
    }
  },

  created() {
    this.initialize();
  },
  beforeDestroy() {
    document
      .querySelector(".v-data-table__wrapper")
      .removeEventListener("scroll", this.scroll);
    if (this.intervalId) clearInterval(this.intervalId);
  },
  mounted() {
    let el = document.querySelector(".v-data-table__wrapper");
    el.addEventListener("scroll", this.scroll);
    this.computeHeight();
  },

  methods: {
    scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (this.options.itemsPerPage < this.devices.length) {
        if (scrollTop + clientHeight >= scrollHeight - 5) {
          this.paginate();
        }
      }
    },

    computeHeight() {
      let el = this.$refs.dataContainer.$el;
      let boxOffset = el.getBoundingClientRect();
      let viewPortHeight = window.innerHeight;
      this.height = viewPortHeight - boxOffset.top;
    },

    paginate() {
      this.options.itemsPerPage = this.options.itemsPerPage + this.rows;
    },

    selectRow(value) {
      if (this.hasSelection) {
        this.selected = this.devices.filter(data => data.id === value.id);
      }
    },

    initialize() {
      this.options.itemsPerPage = this.rows;
      this.loading = true;
      this.$store
        .dispatch("devices/fetchAll")
        .then(async () => {
          await this.fetchHaloSystemReport();
          this.intervalId = periodicCall(
            this.fetchHaloDataLinksAvailability,
            constants.REQUEST_INTERVAL_IN_MILLISECONDS
          );
          if (this.search) {
            this.searchItems(this.search);
          } else {
            this.loadItems = this.devices;
          }
        })
        .catch(error => {
          handleError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    fetchHaloDataLinksAvailability() {
      return this.$store
        .dispatch("devices/fetchHaloDataLinksAvailability")
        .catch(error => handleError(error));
    },

    async fetchHaloSystemReport() {
      try {
        let response = await this.$store.dispatch(
          "devices/fetchDevicesStatus",
          {
            devices: []
          }
        );
        let data = response.data;
        this.$store.commit("devices/loadDevicesStatus", data);
        this.device_key = Math.random();
      } catch (error) {
        handleError(error);
      }
    },
    searchItems(val) {
      this.loadItems = this.devices.filter(o =>
        this.headers
          .filter(item => item.value !== "action")
          .map(item => item.value)
          .some(k => {
            if (o[k]) {
              return (
                o[k]
                  .toString()
                  .toLowerCase()
                  .indexOf(val.toLowerCase()) > -1
              );
            }
          })
      );
    },

    loadMembership(item) {
      let membership = "";
      let membershipTitle = "";
      if (
        item.application_rules.length === 0 ||
        this.applicationRules.length === 0
      ) {
        membership = "";
        membershipTitle = "";
      } else {
        for (let i = 0; i < item.application_rules.length; i++) {
          let applicationRule = this.applicationRules.find(
            data => data.id === item.application_rules[i]
          );
          if (applicationRule) {
            membership += applicationRule.name;
            let hostLists = Object.keys(applicationRule.hosts_list);
            if (hostLists.indexOf(item.id) !== -1) {
              membership += " (host)";
            } else if (applicationRule.hubs_list.indexOf(item.id) !== -1) {
              membership += " (hub)";
            } else {
              membership += "";
            }

            // handle membership title and line break
            if (i === 0) {
              membershipTitle = membership;
            }
            if (i !== item.application_rules.length - 1) {
              membership += "<br>";
            } else {
              membershipTitle +=
                item.application_rules.length > 1
                  ? this.$t("modules.devices.moreApplicationRules", [i])
                  : "";
            }
          }
        }
      }
      return {
        membership: membership,
        title: membershipTitle
      };
    },

    editItem(item) {
      let editedIndex = this.devices.indexOf(item);
      this.$store.commit("devices/updateFormTitle", 2);
      this.$store.commit("devices/updateIndex", editedIndex);
      this.$store.dispatch("devices/editItem", item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.loading = true;
      let confirmed = confirm(this.$t("modules.devices.confirmDelete"));
      if (confirmed) {
        this.$store
          .dispatch("devices/delete", item.id)
          .catch(error => {
            handleError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.loading = false;
      }
    },
    filterDevices() {
      this.searchItems(this.search);

      this.loadItems = this.loadItems.filter(item => {
        const isEnabledFilter =
          this.enabled === null || item.is_enabled === this.enabled;

        const isActivatedFilter =
          this.activated === null || item.is_activated === this.activated;

        return isEnabledFilter && isActivatedFilter;
      });
    },
    openRfRecordingDialog(deviceId) {
      this.$store.commit("devices/updateRfRecordingDeviceId", deviceId);
      this.$store.commit("devices/updateRfRecordingOpenDialog", true);
    },
    handleClear() {
      this.enabled = null;
      this.activated = null;
    }
  }
};
</script>

<style>
tr:hover {
  cursor: pointer !important;
}
</style>
